export default __webpack_public_path__ + "static/media/bg.78f7a8c1.svg";